"use client";
import Tabs from "@/components/primitives/tabs";
import React from "react";
import { usePathname, useRouter } from "next/navigation";
import { CurrentSeason, Sport, formatServerSeason } from "common";
import Select from "@/components/primitives/select";
import { getSeasonOptions } from "@/utils/sports";
import { useParamUpdater } from "@/utils/hooks/navigation";

export interface TeamStatsParams {
  sport: Sport;
  year: string;
  team: string;
  season?: string[];
}

export default function TeamStatsFilter({
  currentSeason,
  params,
}: {
  currentSeason: CurrentSeason;
  params: TeamStatsParams;
}) {
  const router = useRouter();
  const { createParamString } = useParamUpdater();
  console.log("current season", currentSeason);
  const thisSeason = currentSeason.past
    ? currentSeason.past.season
    : currentSeason.current.season;
    const season: string = (params.season?.[0] || formatServerSeason(thisSeason, true)) as string;
  const seasonOptions: Option[] = getSeasonOptions(thisSeason);
  return (
    // <Tabs
    //   variant="pill"
    //   onValueChange={(v) => {
    //     if (v === "players") {
    //       router.replace(createParamString(v, 5) || pathname, {
    //         scroll: false,
    //       });
    //     } else {
    //       return;
    //     }
    //   }}
    //   label="Team View"
    //   value={view}
    //   items={[
    //     {
    //       label: "Team",
    //       value: "team",
    //     },
    //     {
    //       label: "Players",
    //       value: "players",
    //     },
    //   ]}
    // />
    <Select
      label="Select Season"
      value={season}
      options={seasonOptions}
      onValueChange={(v) =>
        router.replace(createParamString(v, 5) || season, {
          scroll: false,
        })
      }
      block
    />
  );
}
